/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EsgConsolidationCreateRequestResponse } from '../../models/esg-consolidation-create-request-response';
import { EsgDisclosureCode } from '../../models/esg-disclosure-code';
import { EsgDisclosureDatapointId } from '../../models/esg-disclosure-datapoint-id';
import { EsgNarrativeAiRequest } from '../../models/esg-narrative-ai-request';

export interface ConsolidationProfileByYearByCodeByDatapointIdNarrativeAi$Params {
  profileId: number;
  year: number;
  code: EsgDisclosureCode;
  dataPointId: EsgDisclosureDatapointId;
      body?: EsgNarrativeAiRequest
}

export function consolidationProfileByYearByCodeByDatapointIdNarrativeAi(http: HttpClient, rootUrl: string, params: ConsolidationProfileByYearByCodeByDatapointIdNarrativeAi$Params, context?: HttpContext): Observable<StrictHttpResponse<EsgConsolidationCreateRequestResponse>> {
  const rb = new RequestBuilder(rootUrl, consolidationProfileByYearByCodeByDatapointIdNarrativeAi.PATH, 'post');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('year', params.year, {});
    rb.path('code', params.code, {});
    rb.path('dataPointId', params.dataPointId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EsgConsolidationCreateRequestResponse>;
    })
  );
}

consolidationProfileByYearByCodeByDatapointIdNarrativeAi.PATH = '/esg/profile/consolidation/{profileId}/{year}/{code}/datapoint/{dataPointId}/narrative-ai';
